import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translation resources
import commonEN from './resources/en/common.json';
import navigationEN from './resources/en/navigation.json';
import formsEN from './resources/en/forms.json';
import commonES from './resources/es/common.json';
import navigationES from './resources/es/navigation.json';
import formsES from './resources/es/forms.json';
import commonFR from './resources/fr/common.json';
import navigationFR from './resources/fr/navigation.json';
import formsFR from './resources/fr/forms.json';
import commonDE from './resources/de/common.json';
import navigationDE from './resources/de/navigation.json';
import formsDE from './resources/de/forms.json';
import commonIT from './resources/it/common.json';
import navigationIT from './resources/it/navigation.json';
import formsIT from './resources/it/forms.json';
import commonEL from './resources/el/common.json';
import navigationEL from './resources/el/navigation.json';
import formsEL from './resources/el/forms.json';

export const resources = {
  en: {
    common: commonEN,
    navigation: navigationEN,
    forms: formsEN,
  },
  es: {
    common: commonES,
    navigation: navigationES,
    forms: formsES,
  },
  fr: {
    common: commonFR,
    navigation: navigationFR,
    forms: formsFR,
  },
  de: {
    common: commonDE,
    navigation: navigationDE,
    forms: formsDE,
  },
  it: {
    common: commonIT,
    navigation: navigationIT,
    forms: formsIT,
  },
  el: {
    common: commonEL,
    navigation: navigationEL,
    forms: formsEL,
  },
} as const;

// Get saved language from localStorage or default to English
const savedLanguage = localStorage.getItem('i18n-language') || 'en';

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLanguage, // Use saved language or default
    fallbackLng: 'en', // Fallback language

    interpolation: {
      escapeValue: false, // React already escapes values
    },

    defaultNS: 'common',
    ns: ['common', 'navigation', 'forms'],

    react: {
      useSuspense: false, // Disable suspense to avoid loading issues
    },

    // Return the key if translation is missing (for debugging)
    returnNull: false,
    returnEmptyString: false,
    // Don't return the key itself, try to find it
    keySeparator: '.',
    nsSeparator: ':',
  });

export default i18n;